const ORDER_STATUS = {
  CANCELED: 'canceled',
  COMPLETED: 'completed',
  DENIED: 'denied',
  IN_PREPARATION: 'in_preparation',
  PENDING_CUSTOMER_APPROVAL: 'pending_customer_approval',
  READY_FOR_PICKUP: 'ready_for_pickup',
  RECEIVED: 'received'
};

// Statuses in lifecycle order (matches the DB enum's logical progression).
// Use this whenever you need to display statuses to the user in a meaningful
// sequence — e.g. a status dropdown — rather than the alphabetical order of
// the ORDER_STATUS map.
const ORDER_STATUS_ORDERED = [
  ORDER_STATUS.RECEIVED,
  ORDER_STATUS.PENDING_CUSTOMER_APPROVAL,
  ORDER_STATUS.IN_PREPARATION,
  ORDER_STATUS.READY_FOR_PICKUP,
  ORDER_STATUS.COMPLETED,
  ORDER_STATUS.DENIED,
  ORDER_STATUS.CANCELED
];

// The status an active order advances to when the restaurant confirms the
// current step. Terminal statuses are absent (no forward step).
const NEXT_STATUS = {
  [ORDER_STATUS.IN_PREPARATION]: ORDER_STATUS.READY_FOR_PICKUP,
  [ORDER_STATUS.READY_FOR_PICKUP]: ORDER_STATUS.COMPLETED,
  [ORDER_STATUS.RECEIVED]: ORDER_STATUS.IN_PREPARATION
};

// Statuses with no further restaurant action (no footer in the detail modal).
const TERMINAL_STATUSES = [
  ORDER_STATUS.CANCELED,
  ORDER_STATUS.COMPLETED,
  ORDER_STATUS.DENIED
];

// Where an order's pickup day sits relative to today. Drives two rules:
// - PAST: status changes happen silently (no customer email).
// - FUTURE: the order can only be denied.
const ORDER_DAY_POSITION = {
  FUTURE: 'future',
  PAST: 'past',
  TODAY: 'today'
};

// Period the filter bar shows. Day/week/month step forward/back by their own
// unit; custom is a free from–to range (no arrows). Each defaults to today.
const ORDER_PERIOD_TYPE = {
  CUSTOM: 'custom',
  DAY: 'day',
  MONTH: 'month',
  WEEK: 'week'
};

// How the board renders for a given period. Only the status kanban supports
// drag-and-drop (and only when the day is today); the others are overviews.
// Month and custom both render a calendar grid over their date range.
const ORDER_VIEW_MODE = {
  CALENDAR: 'calendar',
  DAYS: 'days',
  STATUS: 'status'
};

const VIEW_MODE_BY_PERIOD = {
  [ORDER_PERIOD_TYPE.CUSTOM]: ORDER_VIEW_MODE.CALENDAR,
  [ORDER_PERIOD_TYPE.DAY]: ORDER_VIEW_MODE.STATUS,
  [ORDER_PERIOD_TYPE.MONTH]: ORDER_VIEW_MODE.CALENDAR,
  [ORDER_PERIOD_TYPE.WEEK]: ORDER_VIEW_MODE.DAYS
};

// Statuses that can be reached by dropping a card into a column.
const DROPPABLE_STATUSES = [
  ORDER_STATUS.RECEIVED,
  ORDER_STATUS.IN_PREPARATION,
  ORDER_STATUS.READY_FOR_PICKUP,
  ORDER_STATUS.COMPLETED
];

// Left-to-right column layout. For single-status columns droppableId === the
// status value, so a drop's destination.droppableId is the new status.
// The combined Canceled/Denied column is not a drop target (set via modal).
const ORDER_COLUMNS = [
  {
    droppableId: ORDER_STATUS.RECEIVED,
    id: 'received',
    isDragDisabled: false,
    isDropDisabled: false,
    labelKey: 'columns.received',
    statuses: [ORDER_STATUS.RECEIVED]
  },
  {
    droppableId: 'pending_customer_approval',
    id: 'pending_customer_approval',
    isDragDisabled: true,
    isDropDisabled: true,
    labelKey: 'columns.pending_customer_approval',
    statuses: [ORDER_STATUS.PENDING_CUSTOMER_APPROVAL]
  },
  {
    droppableId: ORDER_STATUS.IN_PREPARATION,
    id: 'in_preparation',
    isDragDisabled: false,
    isDropDisabled: false,
    labelKey: 'columns.in_preparation',
    statuses: [ORDER_STATUS.IN_PREPARATION]
  },
  {
    droppableId: ORDER_STATUS.READY_FOR_PICKUP,
    id: 'ready_for_pickup',
    isDragDisabled: false,
    isDropDisabled: false,
    labelKey: 'columns.ready_for_pickup',
    statuses: [ORDER_STATUS.READY_FOR_PICKUP]
  },
  {
    droppableId: ORDER_STATUS.COMPLETED,
    id: 'completed',
    isDragDisabled: false,
    isDropDisabled: false,
    labelKey: 'columns.completed',
    statuses: [ORDER_STATUS.COMPLETED]
  },
  {
    droppableId: 'canceled_denied',
    id: 'canceled_denied',
    isDragDisabled: false,
    isDropDisabled: true,
    labelKey: 'columns.canceled_denied',
    statuses: [ORDER_STATUS.CANCELED, ORDER_STATUS.DENIED]
  }
];

export {
  DROPPABLE_STATUSES,
  NEXT_STATUS,
  ORDER_COLUMNS,
  ORDER_DAY_POSITION,
  ORDER_PERIOD_TYPE,
  ORDER_STATUS,
  ORDER_STATUS_ORDERED,
  ORDER_VIEW_MODE,
  TERMINAL_STATUSES,
  VIEW_MODE_BY_PERIOD
};
